import { CheckCircleIcon } from '@heroicons/react/24/solid';
import type { FC } from 'react';

import { CircleWithText } from '../../icons/CircleWithText';
import { RadixTypography } from '../../typography';
import { type StepDetails, useStepperContext } from './Stepper';

export interface StepLabelInterface extends StepDetails {
	children: string;
}

export const StepLabel: FC<StepLabelInterface> = ({ children, _index }) => {
	const { activeStep } = useStepperContext();

	return (
		<div className="flex gap-3 items-center my-2">
			{activeStep > Number(_index) ? (
				<CheckCircleIcon
					width={24}
					height={24}
					className="text-yellow"
				/>
			) : (
				<CircleWithText
					text={_index}
					width={24}
					height={24}
					className={
						activeStep < Number(_index) ? 'grey-500' : 'text-yellow'
					}
				/>
			)}
			<RadixTypography
				variant="default"
				// weight={500}
				className={
					activeStep === Number(_index) ? 'grey-200' : 'grey-400'
				}
			>
				{children}
			</RadixTypography>
		</div>
	);
};
